// Catalogo de categorias da curadoria automatica da Shopee.
//
// Cada categoria vira uma busca no productOfferV2 da API oficial de afiliados:
// `keyword` sempre, `catId` (productCatId) quando o id numerico da categoria
// estiver confirmado. A Shopee nao publica a arvore de ids do Brasil e os ids
// nao puderam ser conferidos sem chamada real com credencial; por isso o
// catalogo nasce por palavra-chave (parametro oficial `keyword`).
// ponytail: preencher catId de cada item depois do primeiro teste real (o
// cliente ja envia productCatId quando o campo existe).
export const SHOPEE_CATEGORIES = Object.freeze([
    { id: "celulares", name: "Celulares e acessórios", keyword: "celular" },
    { id: "informatica", name: "Informática", keyword: "notebook" },
    { id: "eletronicos", name: "Eletrônicos e áudio", keyword: "fone bluetooth" },
    { id: "casa", name: "Casa e decoração", keyword: "decoração casa" },
    { id: "cozinha", name: "Cozinha", keyword: "utensílios cozinha" },
    { id: "eletroportateis", name: "Eletroportáteis", keyword: "air fryer" },
    { id: "beleza", name: "Beleza e maquiagem", keyword: "maquiagem" },
    { id: "perfumaria", name: "Perfumes", keyword: "perfume" },
    { id: "saude", name: "Saúde e bem-estar", keyword: "suplemento" },
    { id: "moda-feminina", name: "Moda feminina", keyword: "vestido feminino" },
    { id: "moda-masculina", name: "Moda masculina", keyword: "camiseta masculina" },
    { id: "calcados", name: "Calçados", keyword: "tênis" },
    { id: "bolsas", name: "Bolsas e mochilas", keyword: "bolsa feminina" },
    { id: "relogios", name: "Relógios e acessórios", keyword: "relógio" },
    { id: "bebes", name: "Bebês", keyword: "bebê" },
    { id: "brinquedos", name: "Brinquedos", keyword: "brinquedo" },
    { id: "esportes", name: "Esportes e academia", keyword: "academia" },
    { id: "pets", name: "Pets", keyword: "pet" },
    { id: "automotivo", name: "Automotivo", keyword: "acessórios carro" },
    { id: "ferramentas", name: "Ferramentas", keyword: "ferramenta" },
    { id: "games", name: "Games", keyword: "gamer" },
    { id: "papelaria", name: "Papelaria e escritório", keyword: "papelaria" },
    { id: "mercado", name: "Mercado e bebidas", keyword: "café" },
    { id: "jardim", name: "Jardim e piscina", keyword: "jardinagem" },
    { id: "viagem", name: "Viagem e malas", keyword: "mala de viagem" },
]);
const CATEGORY_BY_ID = new Map(SHOPEE_CATEGORIES.map((category) => [category.id, category]));
export function findCategory(id) {
    return CATEGORY_BY_ID.get(id) ?? null;
}
/** Mantem so ids conhecidos, sem repetir, na ordem recebida. */
export function sanitizeCategoryIds(ids) {
    const seen = new Set();
    for (const id of ids) {
        if (typeof id === "string" && CATEGORY_BY_ID.has(id)) {
            seen.add(id);
        }
    }
    return [...seen];
}
//# sourceMappingURL=categories.js.map